/** @flow */

import {
  GetRevisionHistorySuccess,
  GetRevisionHistoryError,
  GetEmployeeSMSMessagesSuccess,
  GetEmployeeAbsences,
  GetEmployeeAbsencesSuccess,
  GetAlertsTriggered,
  GetAlertsTriggeredSuccess,
  GetAlertsTriggeredError,
  ToggleAlertsTriggeredModal,
  ToggleAddAbsenceModal,
  UpdateAbsenceAddModalData,
  GetEmployeeAbsencesSchemaSuccess,
  GetEmployeeAbsence,
  GetEmployeeAbsenceSuccess,
  UpdateEmployeeAbsence,
  UpdateEmployeeAbsenceSuccess,
  UpdateEmployeeAbsenceError,
  GetEmployeeAbsenceShiftPattern,
  GetEmployeeAbsenceShiftPatternSuccess,
  GetEmployeeAbsenceShiftPatternOptions,
  GetEmployeeAbsenceShiftPatternOptionsSuccess,
  ToggleEmployeeAbsenceShiftPatternModal,
  GetEmployeeInteractionsSuccess,
  ToggleEditEmployeeInteractionModal,
  GetEmployeeAbsenceAdditionalInfoSuccess,
  ToggleEditEmployeeAbsenceAdditionalInfoModal,
  GetAbsenceStatistics,
  GetAbsenceStatisticsSuccess,
  GetAbsenceStatisticsError,
  GetEmployeeAbsenceDocumentsSuccess,
  ToggleEmployeeAbsenceDocumentModal,
  ToggleDeleteEmployeeAbsenceDocumentModal,
  GetManagerNotesSuccess,
  GetManagerNotesError,
  GetEmployeeAbsenceNotificationsSuccess,
  ToggleEmployeeAbsenceNotificationModal,
  ToggleAddEditManagerNotesModal,
  GetAbsenceManagerNotesSchemaSuccess,
  ToggleAbsenceRateTrendRTWInterviewModal,
  RepeatTimeLostAbsenceShiftPattern,
  GetEmployeeNonCancelledAbsencesSuccess,
  GetAbsenceNoteTypesSuccess,
  SubmitTransferAbsence,
  SubmitTransferAbsenceSuccess,
  SubmitTransferAbsenceError,
  ToggleDeleteManagerNoteModal,
  AddManagerNote,
  AddManagerNoteSuccess,
  AddManagerNoteError,
  DeleteManagerNote,
  DeleteManagerNoteSuccess,
  DeleteManagerNoteError,
  EditManagerNote,
  EditManagerNoteSuccess,
  EditManagerNoteError,
  GetManagerNotes,
  ExportManagerNotes,
  ExportManagerNotesSuccess,
  ExportManagerNotesError,
  UpdateEmployeeInteraction,
  UpdateEmployeeInteractionSuccess,
  UpdateEmployeeInteractionError,
  UpdateEmployeeAbsenceShiftPattern,
  UpdateEmployeeAbsenceShiftPatternSuccess,
  UpdateEmployeeAbsenceShiftPatternError,
  GetEmployeeAbsenceNotification,
  GetEmployeeAbsenceNotificationSuccess,
  GetEmployeeAbsenceNotificationError,
  ResendEmployeeAbsenceNotification,
  ResendEmployeeAbsenceNotificationSuccess,
  ResendEmployeeAbsenceNotificationError,
  CreateEmployeeAbsenceDocument,
  CreateEmployeeAbsenceDocumentSuccess,
  CreateEmployeeAbsenceDocumentError,
  DeleteEmployeeAbsenceDocument,
  DeleteEmployeeAbsenceDocumentSuccess,
  DeleteEmployeeAbsenceDocumentError,
  GetEmployeeAbsenceDocument,
  GetEmployeeAbsenceDocumentSuccess,
  GetEmployeeAbsenceDocumentError,
  GetEmployeeBankHolidaysOptionsSuccess,
} from "@modules/shared/constants/actions";
import * as reducers from "./reducers";
import type { AbsencesState } from "./types";
import initialState from "./state";
import { cloneObject } from "@utils/object";

export default (state: AbsencesState = initialState, action: any): Object => {
  const act = {
    [GetRevisionHistorySuccess]: reducers.onGetRevisionHistorySuccess,
    [GetEmployeeSMSMessagesSuccess]: reducers.onGetEmployeeSMSMessagesSuccess,
    [GetRevisionHistoryError]: reducers.onGetRevisionHistoryError,
    [GetEmployeeAbsence]: reducers.setLoading,
    [GetEmployeeAbsenceSuccess]: reducers.onGetEmployeeAbsenceSuccess,
    [GetEmployeeAbsences]: reducers.setLoading,
    [GetEmployeeAbsencesSuccess]: reducers.onGetEmployeeAbsencesSuccess,
    [GetAlertsTriggered]: reducers.setLoading,
    [GetAlertsTriggeredSuccess]: reducers.onGetAlertsTriggeredSuccess,
    [GetAlertsTriggeredError]: reducers.onGetAlertsTriggeredError,
    [ToggleAlertsTriggeredModal]: reducers.onToggleAlertsTriggeredModal,
    [ToggleAddAbsenceModal]: reducers.onToggleAddAbsenceModal,
    [SubmitTransferAbsence]: reducers.onSubmitTransferAbsence,
    [SubmitTransferAbsenceSuccess]: reducers.onSubmitTransferAbsenceSuccess,
    [SubmitTransferAbsenceError]: reducers.onSubmitTransferAbsenceError,
    [UpdateAbsenceAddModalData]: reducers.onUpdateAbsenceAddModalData,
    [GetEmployeeAbsencesSchemaSuccess]: reducers.onGetEmployeeAbsencesSchemaSuccess,
    [UpdateEmployeeAbsence]: reducers.setLoading,
    [UpdateEmployeeAbsenceSuccess]: reducers.onUpdateEmployeeAbsenceSuccess,
    [UpdateEmployeeAbsenceError]: reducers.onUpdateEmployeeAbsenceError,
    [GetEmployeeAbsenceShiftPattern]: reducers.setLoading,
    [GetEmployeeAbsenceShiftPatternSuccess]: reducers.onGetEmployeeAbsenceShiftPatternSuccess,
    [GetEmployeeAbsenceShiftPatternOptions]: reducers.setLoading,
    [GetEmployeeAbsenceShiftPatternOptionsSuccess]:
      reducers.onGetEmployeeAbsenceShiftPatternOptionsSuccess,
    [ToggleEmployeeAbsenceShiftPatternModal]: reducers.onToggleEmployeeAbsenceShiftPatternModal,
    [GetEmployeeInteractionsSuccess]: reducers.onGetEmployeeInteractionsSuccess,
    [ToggleEditEmployeeInteractionModal]: reducers.onToggleEditEmployeeInteractionModal,
    [GetEmployeeAbsenceAdditionalInfoSuccess]: reducers.onGetEmployeeAbsenceAdditionalInfoSuccess,
    [ToggleEditEmployeeAbsenceAdditionalInfoModal]:
      reducers.onToggleEditEmployeeAbsenceAdditionalInfoModal,
    [GetAbsenceStatistics]: reducers.setLoading,
    [GetAbsenceStatisticsSuccess]: reducers.onGetAbsenceStatisticsSuccess,
    [GetAbsenceStatisticsError]: reducers.onGetAbsenceStatisticsError,
    [GetEmployeeAbsenceDocumentsSuccess]: reducers.onGetEmployeeAbsenceDocumentsSuccess,
    [ToggleEmployeeAbsenceDocumentModal]: reducers.onToggleEmployeeAbsenceDocumentModal,
    [ToggleDeleteEmployeeAbsenceDocumentModal]: reducers.onToggleDeleteEmployeeAbsenceDocumentModal,
    [GetManagerNotes]: reducers.setLoading,
    [GetManagerNotesSuccess]: reducers.onGetManagerNotesSuccess,
    [GetManagerNotesError]: reducers.onGetManagerNotesError,
    [GetEmployeeAbsenceNotificationsSuccess]: reducers.onGetEmployeeAbsenceNotificationsSuccess,
    [ToggleEmployeeAbsenceNotificationModal]: reducers.onToggleEmployeeAbsenceNotificationModal,
    [ToggleAddEditManagerNotesModal]: reducers.onToggleAddEditManagerNotesModal,
    [ToggleDeleteManagerNoteModal]: reducers.onToggleDeleteManagerNoteModal,
    [GetAbsenceManagerNotesSchemaSuccess]: reducers.onGetAbsenceManagerNotesSchemaSuccess,
    [ToggleAbsenceRateTrendRTWInterviewModal]: reducers.onToggleAbsenceRateTrendRTWInterviewModal,
    [RepeatTimeLostAbsenceShiftPattern]: reducers.onRepeatTimeLostAbsenceShiftPattern,
    [GetEmployeeNonCancelledAbsencesSuccess]: reducers.onGetEmployeeNonCancelledAbsencesSuccess,
    [GetAbsenceNoteTypesSuccess]: reducers.onGetAbsenceNoteTypesSuccess,
    [AddManagerNote]: reducers.setLoading,
    [AddManagerNoteSuccess]: reducers.setLoaded,
    [AddManagerNoteError]: reducers.setLoaded,
    [DeleteManagerNote]: reducers.setLoading,
    [DeleteManagerNoteSuccess]: reducers.setLoaded,
    [DeleteManagerNoteError]: reducers.setLoaded,
    [EditManagerNote]: reducers.setLoading,
    [EditManagerNoteSuccess]: reducers.setLoaded,
    [EditManagerNoteError]: reducers.setLoaded,
    [ExportManagerNotes]: reducers.setLoading,
    [ExportManagerNotesSuccess]: reducers.setLoaded,
    [ExportManagerNotesError]: reducers.setLoaded,
    [UpdateEmployeeInteraction]: reducers.setLoading,
    [UpdateEmployeeInteractionSuccess]: reducers.setLoaded,
    [UpdateEmployeeInteractionError]: reducers.setLoaded,
    [UpdateEmployeeAbsenceShiftPattern]: reducers.setLoading,
    [UpdateEmployeeAbsenceShiftPatternSuccess]: reducers.setLoaded,
    [UpdateEmployeeAbsenceShiftPatternError]: reducers.setLoaded,
    [GetEmployeeAbsenceNotification]: reducers.setLoading,
    [GetEmployeeAbsenceNotificationSuccess]: reducers.setLoaded,
    [GetEmployeeAbsenceNotificationError]: reducers.setLoaded,
    [ResendEmployeeAbsenceNotification]: reducers.setLoading,
    [ResendEmployeeAbsenceNotificationSuccess]: reducers.setLoaded,
    [ResendEmployeeAbsenceNotificationError]: reducers.setLoaded,
    [CreateEmployeeAbsenceDocument]: reducers.setLoading,
    [CreateEmployeeAbsenceDocumentSuccess]: reducers.setLoaded,
    [CreateEmployeeAbsenceDocumentError]: reducers.setLoaded,
    [DeleteEmployeeAbsenceDocument]: reducers.setLoading,
    [DeleteEmployeeAbsenceDocumentSuccess]: reducers.setLoaded,
    [DeleteEmployeeAbsenceDocumentError]: reducers.setLoaded,
    [GetEmployeeAbsenceDocument]: reducers.setLoading,
    [GetEmployeeAbsenceDocumentSuccess]: reducers.setLoaded,
    [GetEmployeeAbsenceDocumentError]: reducers.setLoaded,
    [GetEmployeeBankHolidaysOptionsSuccess]: reducers.onGetEmployeeBankHolidaysOptionsSuccess,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
